import { Navigate } from "react-router-dom";
import IntelexFrame from "../intelex/IntelexFrame";

export default function InterepTestLoginPage() {
  return (
    <IntelexFrame title="Test account sign in" testLoginPage>
      {({ user }) => {
        const role = String(user?.role || "").toLowerCase();
        const testAccount = Boolean(user?.isTestAccount) || role === "test";
        return <Navigate to={testAccount ? "/interep/exam" : "/interep"} replace />;
      }}
    </IntelexFrame>
  );
}
